<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="epi">
<div class="epigraph">
<p class="epf">“I wear the colours of the little royal maid.”</p>
<p class="ept">— <span class="small">ROBERT LOUIS STEVENSON</span></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-kaiulani-0002.vue?504e9dcc